/* eslint-disable */
import $ from 'jquery';

import axios from "assets/js/request";

import UrlConstants from "assets/const/UrlConstants";
var commonEc = {

    /*
     * common: getItemSyukkaYoteiTdkYmd
     */
    getItemSyukkaYoteiTdkYmd : async function (sItemNo) {
        var _this = this;
        var request = {
            "sItemNo": sItemNo
        };
        const response = await axios.post(UrlConstants.ECSITE + UrlConstants.PT120 + UrlConstants.GET_SYUKKA_YOTEI_YMD, request);
        return response.data.syukkaYoteiYmd;
    },

    /*
     * common: getAnimalQty
     * 数量から匹数を算出する
     */
    getAnimalQty : async function (itemqty, syukkaNum) {
        if (!itemqty || !syukkaNum) {
            return;
        }
        var animalQty = 0;
        animalQty = itemqty * syukkaNum;
        animalQty = isNaN(animalQty) ? 0 : animalQty;
        animalQty = animalQty.toString();
        return animalQty;
    },

    /*
     * common: getItemQty
     * 匹数から数量を算出する
     */
    getItemQty : async function (animalQty, syukkaNum) {
        if (!animalQty || !syukkaNum) {
            return;
        }
        var itemqty = 0;
        itemqty = animalQty / syukkaNum;
        itemqty = isNaN(itemqty) ? 0 : itemqty;
        itemqty = itemqty >= 1 ? itemqty : 0;
        itemqty = itemqty.toString();
        return itemqty;
    }
}


export default commonEc